<template>
    <div class="echart-talbe">
        <!-- 
            :header-cell-style="{background:'#f9f6f2',color:'#333','font-weight': 'bold'}" -->
        <el-table
            ref='tableList'
            :header-cell-style="{background:'#a7754f',color:'#fff'}"
            size='mini'
            :data="echartList"
            border>
            <el-table-column
                label="NO"
                sortable
                align="center"
                width="70"
                prop="num"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="keyName"
                :label="chartName">
            </el-table-column>
            <el-table-column
                align="center"
                sortable
                
                prop="valueName"
                label="频次">
            </el-table-column>
            <!-- :sort-method="(a,b) => sortMethod(a ,b , 'percentage')" -->
            <el-table-column
                align="center"
                sortable
                
                prop="percentage"
                label="百分比">
                <!-- <template scope="scope">
                   <p> {{ scope.row.percentage }}%</p>
                </template> -->
            </el-table-column>
        </el-table>
        <div v-if='isShowDose'>
            <doseModel :show.sync='isShowDose' :doseName="doseName"></doseModel>
        </div>
        
    </div>
</template>

<script>

// 剂量分析图
import doseModel from './dose_model.vue'
import {mapState,mapMutations,mapActions} from 'vuex'
export default {
    components: {
        doseModel
    },
    data () {
        return {
            tableData:[],
            isShowDose:false,
            doseName:'',
        }
    },

    computed: {
        ...mapState({
            chartName:state=>state.excavate.chartName,//接口返回的
            echartList:state=>state.excavate.echartList,
            chartType:state=>state.excavate.chartType,
        })
    },
    mounted () {
        this.getInfo()
    },
    methods: {
        className(){
            return "talbe-bg";
        },
        dose_click(row){
            this.isShowDose = true;
            this.doseName = row.keyName;
        },
        
        sortMethod(before, after,column) {
            return Number(before[column]) - Number(after[column]);
        },
        // 恢复默认排序
        clearSort(){
            this.$refs.tableList.clearSort();
        },
        getInfo(){
            // let tableData = this.echartData.chartJson;
            // tableData.forEach((item,index) => {
            //     this.$set(item,'num',index+1)
            // });
            // console.log(tableData)
            // this.tableData =tableData
        }
    }
}
</script>

<style>

</style>